




import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import echarts from 'echarts'
import {AppConfig} from '@/config/app.config'
import {ChartType} from '@/enums/ChartType'
import EChartOption = echarts.EChartOption
import {$} from 'simpli-web-sdk'

@Component
export default class Chart extends Vue {
  @Prop({type: String, default: ''}) title!: string
  @Prop({type: Array, default: () => []}) colors!: string[]
  @Prop({type: Array, default: () => []}) legends!: string[]
  @Prop({type: Array, default: () => []}) labels!: string[]
  @Prop({type: Array, default: () => []}) data!: number[][]
  @Prop({type: String, default: ChartType.LINE}) type!: ChartType

  echart: echarts.ECharts | null = null

  get chartOptions(): EChartOption {
    return {
      color: this.colors,
      backgroundColor: '#E9E7E7',
      title: {
        text: this.title,
        padding: 0,
        textStyle: {
          color: '#080808',
          fontWeight: 300,
          fontFamily: 'SofiaProLight',
          fontSize: 20,
        },
      },
      grid: {
        top: 80,
        left: 60,
        right: 60,
      },
      legend: {
        data: this.legends,
        padding: [40, 0, 0, 0],
        itemGap: 50,
        textStyle: {
          color: '#353535',
          fontFamily: 'SofiaProLight',
        },
      },
      toolbox: {
        padding: [40, 20, 0, 0],
        showTitle: true,
        feature: {
          saveAsImage: {
            title: $.t('app.download'),
            pixelRatio: 3,
            emphasis: {
              iconStyle: {
                borderColor: AppConfig.primaryColor,
              },
            },
          },
        },
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#E9E9E9',
        borderWidth: 1,
        textStyle: {
          color: '#353535',
        },
      },
      xAxis: {
        data: this.labels,
        axisLine: {show: false},
        boundaryGap: false,
        axisLabel: {
          color: '#666666',
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {show: false},
        splitLine: {
          lineStyle: {
            color: '#999999',
            opacity: 0.3,
          },
        },
        boundaryGap: false,
        minInterval: 1,
        offset: 15,
        axisLabel: {
          color: '#666666',
        },
      },
      series: this.series,
    }
  }

  get series() {
    return this.data.map((data: number[], i: number) => ({
      name: this.legends[i],
      type: this.type,
      smooth: true,
      stack: this.type === ChartType.BAR ? '-' : null,
      lineStyle: {
        width: 2,
      },
      barWidth: 20,
      data,
    }))
  }

  @Watch('chartOptions', {deep: true})
  refreshEvent() {
    if (this.echart) {
      this.echart.setOption(this.chartOptions, true)
    }
  }

  mounted() {
    const el = this.$refs.echart as HTMLDivElement

    this.echart = echarts.init(el)

    this.echart.setOption(this.chartOptions)
  }
}
